// extracted by mini-css-extract-plugin
export default {"header_logo":"ui_header_logo__eTGID"};